export enum FacilityType {
  STORAGE = 'STORAGE',
  FACTORY = 'FACTORY',
  FACTORY_AND_STORAGE = 'FACTORY_AND_STORAGE',
}